import Actor from "components/Activities/Actor";
import ItemObject from "components/Activities/ItemObject";
import { ErrorBoundary } from "components/Shared";
import { translate } from "lib";
import React from "react";

const ViewDocument = ({ activity }: { activity: tcpinpoint.ActivityItem }) => (
	<ErrorBoundary>
		<Actor actor={activity.attributes.item.actor} /> {translate("viewed")}{" "}
		<ItemObject object={activity.attributes.item.object} />{" "}
	</ErrorBoundary>
);

export default ViewDocument;
